import React, { Component } from "react";
import { getBaseURL } from "components/helpers/HostURLHelper.jsx";
import { withStyles } from "@material-ui/core/styles";
import ComboBox from "./core/ComboBox.jsx";
import ReportListItem from "./core/ReportListItem.jsx";
import Grid from "@material-ui/core/Grid";
import { formatDateWithoutTime } from "components/helpers/DateTimeHelper.jsx";
import qs from "query-string";
import AnalystTestsLOV from "./common/AnalystTestsLOV.jsx";

const styles = (theme) => ({});

class AnalystTestHome extends Component {
  state = {
    selectedTestPaper: "",
    allSchedules: [],
    selectedTestPaperOption: null,
    program_id: "",
    test_type_id: "",
    allPrograms: [],
    allTestTypes: [],
  };

  componentDidMount() {
    const paper_id = qs.parse(this.props.location.search).paper_id;
    this.setState({ selectedTestPaper: paper_id });
    this.fetchPrograms();
    this.fetchTestTypes();
  }

  fetchPrograms = () => {
    $.get(getBaseURL() + "/global_programs").done((data) => {
      const allPrograms = [
        { id: "", name: "All" },
        ...JSON.parse(data)?.programs,
      ];
      this.setState({ allPrograms });
    });
  };

  fetchTestTypes = () => {
    $.get(getBaseURL() + "/get-test-types.json").done((data) => {
      const allTestTypes = [{ id: "", name: "All" }, ...data.test_types];
      this.setState({ allTestTypes });
    });
  };

  handleProgramChange = (e, option) => {
    this.setState({
      program_id: option?.id || "",
      selectedTestPaper: "",
      selectedTestPaperOption: null,
    });
  };

  handleTestTypeChange = (e, option) => {
    this.setState({
      test_type_id: option?.id || "",
      selectedTestPaper: "",
      selectedTestPaperOption: null,
    });
  };

  goToMarksList = (e) => {
    var selectedTestPaper = this.state.selectedTestPaper;
    if (selectedTestPaper) {
      this.props.history.push(
        "/analysis/test/marks?paper_id=" + selectedTestPaper
      );
    } else {
      alert("Please select a Test");
    }
  };

  goToCampusAttendanceAnalysis = (e) => {
    var selectedTestPaper = this.state.selectedTestPaper;
    if (selectedTestPaper) {
      this.props.history.push(
        "/analysis/test/attendance?paper_id=" + selectedTestPaper
      );
    } else {
      alert("Please select a Test");
    }
  };

  goToSubjectWiseSectionAnalysis = (e) => {
    var selectedTestPaper = this.state.selectedTestPaper;
    if (selectedTestPaper) {
      this.props.history.push(
        "/analysis/test/subjects/sections?paper_id=" + selectedTestPaper
      );
    } else {
      alert("Please select a Test");
    }
  };

  goToToppersList = (e) => {
    var selectedTestPaper = this.state.selectedTestPaper;
    if (selectedTestPaper) {
      this.props.history.push(
        "/analysis/test/toppers?paper_id=" + selectedTestPaper
      );
    } else {
      alert("Please select a Test");
    }
  };

  goToQuestionsWiseReport = (e) => {
    var selectedTestPaper = this.state.selectedTestPaper;
    if (selectedTestPaper) {
      this.props.history.push(
        "/analysis/test/questions?paper_id=" + selectedTestPaper
      );
    } else {
      alert("Please select a Test");
    }
  };

  onSelectSchedule = (option) => {
    this.setState({
      selectedTestPaper: option.paper_id,
      selectedTestPaperOption: option,
    });
  };

  render() {
    const { classes } = this.props;
    const { selectedTestPaper } = this.state;
    return (
      <React.Fragment>
        <Grid container spacing={2} style={{ marginBottom: 16 }}>
          <Grid item xs={6} sm={3}>
            <ComboBox
              options={this.state.allPrograms}
              onChange={this.handleProgramChange}
              label="Program"
              optionLabel={(opt) =>
                opt?.short_name ? opt?.short_name : opt?.name
              }
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <ComboBox
              options={this.state.allTestTypes}
              onChange={this.handleTestTypeChange}
              label="Test Type"
              optionLabel={(opt) =>
                opt?.short_name ? opt?.short_name : opt?.name
              }
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <AnalystTestsLOV
              onSelectSchedule={this.onSelectSchedule}
              program_id={this.state.program_id}
              test_type_id={this.state.test_type_id}
              {...this.props}
            />
          </Grid>
        </Grid>

        <div style={{ padding: "30px 0px", minHeight: "10vh" }}>
          <Grid container spacing={4}>
            <Grid item sm={12} md={4}>
              <ReportListItem
                isDisabled={selectedTestPaper ? false : true}
                onView={this.goToMarksList}
                role={{
                  title: "Marks List",
                  subtitle: "Marks and Ranks list for all students",
                }}
              />
            </Grid>
            <Grid item sm={12} md={4}>
              <ReportListItem
                isDisabled={selectedTestPaper ? false : true}
                onView={this.goToCampusAttendanceAnalysis}
                role={{
                  title: "Attendance Analysis",
                  subtitle: "Campus wise attendance analysis",
                }}
              />
            </Grid>
            <Grid item sm={12} md={4}>
              <ReportListItem
                isDisabled={selectedTestPaper ? false : true}
                onView={this.goToSubjectWiseSectionAnalysis}
                role={{
                  title: "Subject Wise Analysis",
                  subtitle: "Subject Wise Sections Average Analysis",
                }}
              />
            </Grid>
            <Grid item sm={12} md={4}>
              <ReportListItem
                isDisabled={selectedTestPaper ? false : true}
                onView={this.goToToppersList}
                role={{
                  title: "Toppers List",
                  subtitle: "Top performers list from all branches",
                }}
              />
            </Grid>
            <Grid item sm={12} md={4}>
              <ReportListItem
                isDisabled={selectedTestPaper ? false : true}
                onView={this.goToQuestionsWiseReport}
                role={{
                  title: "Questions Analysis",
                  subtitle: "Question wise analysis for all students",
                }}
              />
            </Grid>
          </Grid>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(AnalystTestHome);
